import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ReactComponent as Chart } from "../../../Assets/Image/svg/chart.svg";
import {
    AiOutlineExclamationCircle,
    AiOutlineDesktop,
    AiOutlineGift,
    AiOutlineLike,
    AiOutlineTeam,
    AiOutlineFile,
    AiOutlineLock,
    AiOutlineBell,
} from "react-icons/ai";
import { ReactComponent as Graduation } from "../../../Assets/Image/svg/graduation.svg";
import { FaRegUserCircle, FaCertificate } from "react-icons/fa";
import { HiOutlineTicket } from "react-icons/hi";
import { BsSun } from "react-icons/bs";
import { BiCommentDetail, BiCertification, BiFilterAlt } from "react-icons/bi";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import Sidebar from "../Sidebar/Sidebar";
import { useParams, useLocation } from "react-router-dom";

const sideBarCourse = [
    {
        icon: <AiOutlineExclamationCircle />,
        title: "  اطلاعات کلی بوت کمپ",
        link: "generalinfo",
    },
    { icon: <AiOutlineDesktop />, title: "جلسات", link: "sections" },
    { icon: <HiOutlineTicket />, title: "  بلیت ها", link: "tickets" },
    { icon: <AiOutlineGift />, title: "کد تخفیف ", link: "off" },
    { icon: <BsSun />, title: "ایده ها ", link: "idea" },
    { icon: <AiOutlineLike />, title: "اولویت ها ", link: "Priority" },
    { icon: <AiOutlineLock />, title: "مدیریت نقش‌ها", link: "roles" },
    { icon: <AiOutlineTeam />, title: "تیم ها ", link: "teams" },
    { icon: <AiOutlineFile />, title: " فایل ها ", link: "file" },
    { icon: <BiCommentDetail />, title: "  نظرسنجی ", link: "survey" },
    { icon: <BiCertification />, title: "  مدارک ", link: "document" },
    { icon: <BiFilterAlt />, title: "  داوری ", link: "arbitration" },
    {
        icon: <AiOutlineBell />,
        title: "  پیام های بوت کمپ ",
        link: "adminmessage",
    },
    { icon: <Chart />, title: "  بازگشت به پیشخوان اصلی ", link: "/dashboard" },
];
function CourseDashboardLayout(props) {
    const location = useLocation();
    const [name, setName] = useState("");
    useEffect(() => {
        if (location.state?.title) setName(location.state?.title);
    }, [location]);

    return (
        <div className="grid grid-cols-5">
            <div>
                <Sidebar menu={sideBarCourse} scroll={true} />
            </div>
            <main className="col-span-4">
                <div className="flex justify-between bg-white-dark py-[1.2rem] pr-[1.7rem] pl-[3.7rem] mb-[.7rem]">
                    <h2 className="text-light-prim1 text-[1.6rem]">{name}</h2>
                    <div className="flex items-center coursedashboard__side-title-icon">
                        <Graduation className="h-[2rem] ml-[3rem]" />
                        <FaRegUserCircle className="text-[1.5rem]" />
                    </div>
                </div>
                <div className=" pr-[1.7rem] pl-[5rem]">
                    <Breadcrumb className="mb-[5rem]" />
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
export default CourseDashboardLayout;
